export default __webpack_public_path__ + "static/media/astronaut.4cbe201e.png";